<!--
@负责人: zhijie.huang
@创建时间: 2018-10-31
@版本: v2.0.0
@描述: 导出提示 mixin 组件
@使用方法:
import exportTips from '@/components/mixins/exportTips'
import CmdbBiz from '@/logic/cmdb/cmdbBiz'

export default {
  mixins: [dic, exportTips],
  data () {
    return: {
      doExport: null
    }
  }
  methods: {
    e_export () {
      const search = extend({}, this.form)
      if (!this.doExport) this.doExport = this.exportTable()
      this.doExport(search)
    },
    exportTable () {
      const that = this
      const list = Object.assign({}, that.$t('hostList.table'))
      delete list.id
      const dictionary = []
      for (const key in DIC_MAP) {
        dictionary.push({
          relate: key,
          type: that.dDictionary[DIC_MAP[key]]
        })
      }
      return function (search) {
        that.exRenderBefore()
        CmdbBiz.exportHostList(
          list,
          search,
          ['createTime'],
          dictionary,
          that.exRenderTips,
          that.exRenderFail
        )
      }
    }
  }
}

-->
<script>
export default {
  data () {
    return {}
  },
  methods: {
    exRenderBefore () {
      this.$message({
        message: this.$t('component.exportStart'),
        duration: 0
      })
    },
    exRenderTips (data) {
      // console.info(data)
      const h = this.$createElement
      // <el-progress :percentage="70"></el-progress>
      const current = Number(data.currentPage)
      const total = Number(data.totalPageCount)

      if (current < total) {
        const title = `${this.$t('component.exporting')}： ${current} / ${total}`
        const percent = parseInt(current / total * 100)

        this.$message.closeAll()
        this.$message({
          message: h('div', {
            style: {
              width: '100%',
              textAlign: 'center'
            }
          }, [
            h('span', null, [title]),
            h('el-progress', {
              props: {
                percentage: percent
              }
            })
          ]),
          duration: 0
        })
      } else {
        this.$message.closeAll()
        this.$message({
          message: this.$t('component.exportSuccess'),
          type: 'success'
        })
        window.location.href = data.downUrl
      }
    },
    exRenderFail (data) {
      this.$message.closeAll()
      if (typeof data === 'object') data = JSON.stringify(data)
      this.$message({
        message: `${this.$t('component.exportFail')}：${data}`,
        type: 'error'
      })
    }
  }
}
</script>
